<template>
  <div>
    <div class="tw-font-medium tw-text-black tw-text-xl">Select Model</div>
    <div class="select-modal-wrapper tw-w-full tw-flex tw-flex-wrap tw-gap-6 tw-my-6">
      <v-select
        label="Select Year"
        :items="years"
        class="custom-select tw-w-full sm:tw-w-fit"
        variant="outlined"
        v-model="selectedYear"
        @update:modelValue="onYearChange"
        :disabled="years.length == 0"
      ></v-select>
      <v-select
        label="Select make"
        :items="divisions"
        variant="outlined"
        class="custom-select tw-w-full sm:tw-w-fit"
        v-model="selectedMake"
        :disabled="!selectedYear || divisions.length == 0"
        @update:modelValue="onMakeChange"
      ></v-select>
      <v-select
        class="custom-select tw-w-full sm:tw-w-fit"
        label="Select model"
        variant="outlined"
        :items="models"
        v-model="selectedModel"
        @update:modelValue="getUpdatedSelectModel"
        :disabled="!selectedYear || !selectedMake || models.length == 0"
      ></v-select>
    </div>
    <div class="tw-w-full tw-flex tw-justify-end next-btn">
      <v-btn
        :disabled="!selectedMake || !selectedModel || !selectedYear || !selectedModalDetails"
        class="tw-h-9 tw-w-24 !tw-bg-[#2E66FF] !tw-text-white hover:!tw-bg-[#F5D101]"
        variant="tonal"
        @click="getDataUpdateStep"
      >
        Next
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { useCarsStore } from '@/stores/useCarsStore';
import { storeToRefs } from 'pinia';
import { useVariablesStore } from '@/stores/useVariablesStore';
import { useSelectionQuery } from '@/composables/useSelectionQuery';

const emit = defineEmits(['nextStep']);
const variablesStore = useVariablesStore();
const carStore = useCarsStore();
const {
  years,
  selectedMake,
  selectedModel,
  selectedYear,
  divisions,
  models,
  selectedModalDetails,
  customMsg,
  modelVariantId,
} = storeToRefs(carStore);
const {
  getYears,
  getDivisions,
  getModels,
  getSelectedModel,
  getCompareDetails,
  getStyleImages,
} = carStore;
const { ensureHydrated, syncQueryToUrl } = useSelectionQuery();

watch(modelVariantId, async () => {
  await getStyleImages();
});

const getDataUpdateStep = async () => {
  if (selectedModalDetails.value?.[0]) {
    carStore.$patch({
      selectedVariantDetails: selectedModalDetails.value[0],
    });
  }
  await getCompareDetails();
  variablesStore.$patch({
    selectedForCompare: [],
    selectVariants: [],
  });
  customMsg.value = '';
  syncQueryToUrl();
  emit('nextStep'); // HomeView advances global currentStep
};
const getUpdatedSelectModel = async () => {
  carStore.$patch({
    modelsCompareDetails: null,
    selectedModalDetails: null,
    modelVariantId: null,
    selectedColor: null,
  });
  syncQueryToUrl();
  await getSelectedModel();
  syncQueryToUrl();
};

const onYearChange = async () => {
  carStore.$patch({
    selectedMake: null,
    selectedModel: null,
    selectedModalDetails: null,
    modelVariantId: null,
    selectedColor: null,
    divisions: [],
    models: [],
  });
  syncQueryToUrl();
  await getDivisions();
  syncQueryToUrl();
};

const onMakeChange = async () => {
  carStore.$patch({
    selectedModel: null,
    selectedModalDetails: null,
    modelVariantId: null,
    selectedColor: null,
    models: [],
  });
  syncQueryToUrl();
  await getModels();
  syncQueryToUrl();
};

async function initDefaultValues() {
  await ensureHydrated();
  if (!years.value.length) {
    await getYears();
  }
  if (selectedYear.value && !divisions.value.length) {
    await getDivisions({ preserveSelection: true });
  }
  if (selectedMake.value && !models.value.length) {
    await getModels({ preserveSelection: true });
  }
  carStore.$patch({
    isLoading: false,
  });
}

onMounted(() => {
  initDefaultValues();
});
</script>

<style lang="css">
.selected-default .v-label {
  @apply !tw-text-black;
}
.custom-select .v-field--focused .v-field-label {
  @apply tw-text-[#b58af3];
}
.selected-modal-wrapper .v-field__prepend-inner > .v-icon,
.v-field__append-inner > .v-icon,
.v-field__clearable > .v-icon {
  font-size: large !important;
}
</style>
